import { io } from "socket.io-client";

const SOCKET_URL = "https://api.surajrestaurant.in";

export const socket = io(SOCKET_URL, {
    transports: ["websocket", "polling"],
    withCredentials: true,
});